module.exports = __webpack_public_path__ + "static/img/slide-1.9263db54.jpg";